module.exports = __webpack_public_path__ + "img/3.06d92276.png";